export { default } from './DepthSliderSection';
export type { DepthSliderSectionProps, DepthSliderSlide } from './DepthSliderSection';
